import classNames from 'classnames';
import React from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
  className?: string;
};

const ProductCardSkeleton: React.FC<Props> = ({ className }) => {
  return (
    <div className={twMerge(classNames('w-[150px] h-full', className))}>
      <div className="rounded-2xl overflow-hidden w-full min-h-[150px] skeleton bg-surface-200-bg relative">
        <div className="w-full h-full default-img pt-[100%]"></div>
      </div>
      <div className="h-10 mt-2 mb-5 mx-2.5 bg-surface-200-bg skeleton"></div>
      <div className="h-3 mt-[5px] mb-1.5 mx-2.5 bg-surface-200-bg skeleton"></div>
      <div className="h-3 mt-[5px] mx-2.5 mb-1.5 w-1/2 bg-surface-200-bg skeleton"></div>
      <div className="h-3 mt-[5px] mx-2.5 mb-1.5 w-3/4 rounded-700 bg-surface-200-bg skeleton"></div>
    </div>
  );
};

export default ProductCardSkeleton;
